module.exports = __webpack_public_path__ + "fonts/iconfont.b9b932b.ttf";